import React, { useState, useEffect } from 'react';

const UnLikeButton = ({ likedCount, onLikeChange }) => {
  const [animate, setAnimate] = useState(false);
  const [currentIP, setCurrentIP] = useState(null);
  const [ipChecked, setIPChecked] = useState(false);

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        setCurrentIP("113");
        setIPChecked(true);
      } catch (err) {
        console.error('Failed to fetch IP:', err);
        setIPChecked(true); // still enable the UI
      }
    };
    fetchIP();
  }, []);

  const handleClick = () => {
    if (!ipChecked || !currentIP) return;

    const storedIP = localStorage.getItem('dislike_ip');

    if (storedIP === currentIP) {
      // IP already used → send original count
      if (onLikeChange) onLikeChange(likedCount);
      return;
    }

    // IP is new → increment count and store IP
    const updatedCount = likedCount + 1;
    localStorage.setItem('dislike_ip', currentIP);
    setAnimate(true);
    setTimeout(() => setAnimate(false), 500);

    if (onLikeChange) onLikeChange(updatedCount);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {animate && (
          <span style={{
            position: 'absolute',
            top: '-10px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '16px',
            opacity: 0,
            animation: 'sparkle 0.5s ease-out',
            pointerEvents: 'none',
          }}>✨</span>
        )}

        <button
          onClick={handleClick}
          disabled={!ipChecked}
          style={{
            padding: '4px 10px',
            fontSize: '12px',
            cursor: ipChecked ? 'pointer' : 'not-allowed',
            backgroundColor: '#f9f9f9',
            color: 'black',
            border: '1px solid #ddd',
            borderRadius: '4px',
            position: 'relative',
            transition: 'transform 0.2s ease',
            transform: animate ? 'scale(1.1)' : 'scale(1)',
          }}
        >
          👎 Dislike
        </button>
      </div>

      <style>{`
        @keyframes sparkle {
          0% { opacity: 0; transform: translateX(-50%) translateY(0px) scale(0.8); }
          50% { opacity: 1; transform: translateX(-50%) translateY(-10px) scale(1.2); }
          100% { opacity: 0; transform: translateX(-50%) translateY(-20px) scale(0.8); }
        }
      `}</style>
    </div>
  );
};

export default UnLikeButton;
